module.exports = __webpack_public_path__ + "static/media/header-3.24f76734.gif";